export default "__VITE_ASSET__cae6d542__"